<div id="countdown">
  <svg *ngIf="showCircle">
    <circle [ngStyle]="animationStyle" id="animation" r="18" cx="20" cy="20"></circle>
  </svg>
</div>
<div id="countdown-number">
  {{ displayTime }}
</div>